import { render, staticRenderFns } from "./_print-products-matrix.component.vue?vue&type=template&id=4f2a1714&scoped=true"
import script from "./_print-products-matrix.component.vue?vue&type=script&lang=js"
export * from "./_print-products-matrix.component.vue?vue&type=script&lang=js"
import style0 from "./_print-products-matrix.component.vue?vue&type=style&index=0&id=4f2a1714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2a1714",
  null
  
)

export default component.exports